import HTTPService from '../HTTPService'

class Conversation {
  getAll (companySlug, page = 1, search = '', tags = '') {
    const params = `?page=${page}${search ? `&search=${search}` : ''}${tags ? `&tags=${tags}` : ''}`

    return HTTPService.get(`company/${companySlug}/conversation${params}`)
  }

  getOne (companySlug, clientId) {
    return HTTPService.get(`company/${companySlug}/conversation/${clientId}`)
  }

  unread (companySlug) {
    return HTTPService.get(`company/${companySlug}/conversation/unread`)
  }
}

export default new Conversation()
